
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteDefaultPipe",
      resolverType: "mutation",
      routePath: "/deleteDefaultPipe",
      httpMethod: "POST",
    });
  